<template>
  <article itemprop="articleBody">
    <header>
        <h1>Deine Ergebnisse</h1>
        <h2>Du hast {{ results.result.correct_count }} von {{ results.exam.questions.data.length }} Fragen richtig beantwortet.</h2>
    </header>

    <a href="https://shop.studyhelp.de/" target="_blank">
      <img src="/static/shop.png" alt="Lernhefte von StudyHelp" title="Lernhefte von StudyHelp">
    </a>

    <div class="result-container" v-if="!loading">
        <div class="result" v-for="question in this.results.exam.questions.data">
            <div class="question">
                <p><strong>{{ question.text }}</strong></p>
            </div>
            <div class="answer your-choise">
                Deine Antwort:
                <p v-bind:class="{ wrong: !solutionIsCorrect(question.id), right: solutionIsCorrect(question.id) }">{{ getSelectedSolution(question.id).text }}</p>
            </div>
            <div class="answer proper">
                Lösung:
                <p>{{ getCorrectSolution(question.id).text }}</p>
            </div>
        </div>
    </div>
    <div class="buttons">
        <a href="#" class="cta-button" @click.stop.prevent="resetExam()"><span>Jetzt erneut testen</span></a>
        <a href="https://www.studyhelp.de?utm_source=lerncheck&utm_medium=link&utm_campaign=lerncheck" target="_blank" class="cta-button button">
                    Zu den Intensivkursen
                    <i class="fa fa-angle-right right" aria-hidden="true"></i>
       </a>
    </div>
  </article>
</template>

<style language="scss" scoped>
h1 {
  color: black;
}
h2 {
  color: black;
}
a > img {
  box-shadow: 10px 5px 5px lightgrey;
}
.fullwidth-with-video .top-line {
    padding-bottom: 10px;
}
.fullwidth-with-video strong {
    font-family: Montserrat,sans-serif;
    font-size: 28px;
}
@media (max-width:568px) {
.fullwidth-with-video strong {
    font-family: Montserrat,sans-serif;
    font-size: 20px;
}
}
.fullwidth-with-video .inner {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-flow: row wrap;
    flex-flow: row wrap;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin: 20px 0 0;

}
.fullwidth-with-video .left {
    -webkit-box-flex: 1;
    -ms-flex: 1 400px;
    flex: 1 400px;
    padding-right:40px;
}
.fullwidth-with-video .right {
    -webkit-box-flex: 1;
    -ms-flex: 1 300px;
    flex: 1 300px;
}
.fullwidth-with-video .right p{
    font-size:18px;
    padding-bottom:10px;
}
.fullwidth-with-video .right p strong{
    font-size:18px;
    font-weight:500;
}
.fullwidth-with-video .right button{
    margin-left:0px;
}
.badge {
    display: inline-block;
    padding: .25em .4em;
    font-size: 100%;
    font-weight: 700;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: .25rem;
    background:#f5d78b;
    margin-top:5px;
}
@media (min-width:568px) {
.button {
  margin-left:10px;
}
}
</style>

<script>
import axios from 'axios';
import config from '../config.js';

export default {
  data: function() {
    return {
      loading: true,
    }
  },
  methods: {
    loadResults: function() {
      axios.get(config.api_url + '/exam/result/' + this.$route.params.uid)
        .then(response => {
          this.results = response.data;
          this.loading = false;
        })
    },
    getSelectedSolution: function(questionId) {
      if (!this.results.exam) {
        return {
          id: 0,
          text: '-'
        }
      }
      var question = this.results.exam.questions.data.find(item => item.id == questionId);
      var selectedChoice = this.results.result.challenges.data.find(item => item.question_id == question.id);
      var selectSolution = question.solutions.data.find(item => item.solution_id == selectedChoice.solution_choice);
      if (!selectSolution)
        return {
          id: 0,
          text: '-'
        };
      return selectSolution;
    },
    getCorrectSolution: function(questionId) {
      var question = this.results.exam.questions.data.find(item => item.id == questionId);
      var correctSolution = question.solutions.data.find(item => item.solution_id == question.correct_solution_id);
      if (!correctSolution)
        return {
          id: 0,
          text: '-'
        };
      return correctSolution;
    },
    solutionIsCorrect: function(questionId) {
      return this.getCorrectSolution(questionId).solution_id == this.getSelectedSolution(questionId).solution_id;
    },
    resetExam: function () {
      this.$store.dispatch('updateExam', null)
        .then(() => {
            this.$router.push({ name: 'home' });
        });
    }
  },
  mounted: function() {
    this.loadResults();
    gtag('config', 'UA-51770849-8', {'page_path': '/results'});
  },
  watch: {
    results: function() {
      this.$nextTick(function() {
        MathJax.Hub.Queue(["Typeset",MathJax.Hub]);
      })
    }
  },
  computed: {
    results: {
      get () {
        return this.$store.getters.results;
      },
      set (value) {
        this.$store.dispatch('updateResults', value);
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Results.vue